module.exports = __webpack_public_path__ + "img/Metastasis-PRCA_10X_ACC.52f5d1b8.png";